import { render, staticRenderFns } from "./ModalInfoCert.vue?vue&type=template&id=5a5dae36"
import script from "./ModalInfoCert.vue?vue&type=script&lang=js"
export * from "./ModalInfoCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports